import { defineComponent, ref } from 'vue';
import useTransactionsStore from '@/store/modules/transactions';
export default defineComponent({
    name: 'CurrencyBadge',
    emits: ['selected'],
    props: {
        currency: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
            validator: (val) => ['Currency', 'Coin'].includes(val),
            default: 'Currency',
        },
    },
    setup(props, { emit }) {
        const currencyValue = ref(props.currency);
        const badgeType = ref(props.type);
        const transactionStore = useTransactionsStore();
        const onBadgeClicked = (event) => {
            // if the token has been sent in via query parameters and the badge type is 'Coin',
            // we do not want it to be editable
            if (!transactionStore.selectedCrypto.editable &&
                badgeType.value === 'Coin') {
                return;
            }
            // if the currency if sent via query params, it should not be editable
            if (!transactionStore.selectedCurrency.editable &&
                badgeType.value === 'Currency') {
                return;
            }
            const badge = event.currentTarget;
            const badgeValue = badge.getElementsByClassName('currency-badge-text')[0]
                .innerText;
            const selectedBadgeType = badge.attributes['data-badge_type'].value;
            emit('selected', { type: selectedBadgeType, value: badgeValue });
        };
        const onKeyPress = () => {
            console.log();
        };
        return {
            currencyValue,
            onBadgeClicked,
            badgeType,
            onKeyPress,
        };
    },
});
